import React, { useState } from 'react'
import { Modal, Form } from 'react-bootstrap'
import SubmitButton from '../Common/buttons/SubmitButton'
import { useForm } from 'react-hook-form'
import { ApiHook } from '../../hooks/apiHook'
import CoinPayment from '../../views/payment/CoinPayment'
import { toast } from 'react-toastify'
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from 'react-redux'
import { BASE_URL } from '../../config/config'
function FundModal({ show, showModal, t }) {
    const { register, formState: { errors }, trigger, watch, setValue } = useForm();
    const queryClient = useQueryClient()
    const adminCoindetails = ApiHook.CallGetAdmincoinId()
    const reinvestment = ApiHook.CallReinvest()
    const [activeStep, setActiveStep] = useState(1);
    const [activeTab, setActiveTab] = useState("");

    const [submitButtonActive, setSubmitButtonActive] = useState(true);
    const username = useSelector(
        (state) => state.dashboard?.appLayout?.user?.username
    );
    const [fileResponse, setFileResponse] = useState({
        success: null,
        error: null,
    });
    const [file, setFile] = useState(null);
    const close = () => {
        showModal(false);
        queryClient.invalidateQueries({ queryKey: ["dashboard-user-profile"] })
    };
    const Upload = ApiHook.CallBankUpload(
        "re-invest",
        username,
        setSubmitButtonActive,
        setValue,
        setFileResponse
    );
    const deleteBankReciept = ApiHook.CallDeleteBankReceipt(
        setSubmitButtonActive,
        setValue,
        setFileResponse,
        setFile
    )

    const steps = ["Step 1", "Step 2"];
    const nextHandler = async () => {
        const valid = await trigger();
        if (valid) {
            setActiveStep(activeStep + 1);
        }
    };
    const previousHandler = () => {
        setActiveStep(activeStep - 1);
    };
    const formValues = watch();
    const handleDeleteBankReciept = () => {
        const data = {
            filepath: formValues?.bankReceipt,
            type: "re-invest"
        }
        if (formValues?.bankReceipt) {
            deleteBankReciept.mutateAsync(data);
        }
    }

    const paymentMethods = ApiHook.CallPaymentMethods("repurchase")
    console.log("==paymentMethods====", paymentMethods.data)

    const handlePaymentTabClick = (tabId, title) => {
        setActiveTab(tabId);

        setValue("paymentType", tabId, { shouldValidate: true }); // Set the selected payment
    };

    const handleSubmit = async (paymentId, coin) => {
        console.log("======paymentId=====", paymentId, coin)
        try {
            const payload = {
                amount: Number(formValues.amount),
                coin: coin,
                paymentId
            }
            const response = await reinvestment.mutateAsync(payload)
            if (response.status) {
                if (response?.data?.checkout_url) {
                    window.location.href = response.data.checkout_url
                } else {
                    queryClient.invalidateQueries({ queryKey: ["dashboard-user-profile"] })
                    showModal(false)
                    toast.success('successfull')
                }
            }

            console.log("=====response=====", response)
        } catch (error) {

        }
    }

    const handleFileChange = (event) => {
        setFileResponse({
            success: null,
            error: null,
        });
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
    };
    const handleUpload = () => {
        const type = "re-invest";
        if (file) {
            Upload.mutate(file, type);
        }
    };
    return (
        <Modal
            show={show}
            onHide={close}
            dialogClassName="custom-modal-dialog"
            centered
            backdrop="static"
            size="lg"
        >
            <Modal.Header className='reinvestModal'>{t('reInvest')}</Modal.Header>
            <Modal.Body style={{ padding: "0px" }}>
                <div className="row align-items-center">

                    <div className="col-md-12">

                        <div className="modal_change_password_right_cnt">
                            <div className="main-content-regsiter" style={{ background: 'none', boxShadow: 'none' }}>
                                <div className="wizard-form py-4 my-2">
                                    <ul id="progressBar" className="progressbar px-lg-5 px-0">
                                        {steps.map((step, index) => (
                                            <li
                                                key={`step-${index + 1}`}
                                                id={`progressList-${index + 1}`}
                                                className={`d-inline-block w-25 position-relative text-center float-start progressbar-list ${index <= activeStep - 1 ? "active" : ""
                                                    }`}
                                            >
                                                {step}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                {activeStep === 1 && (
                                    <div className="form-group mb-2">
                                        <Form.Group>
                                            <Form.Label>{t('amount')}</Form.Label>
                                            {/* <Form.Control
                                                {...register("amount", {
                                                    required: {
                                                        value: true,
                                                        message: t("this_field_is_required"),
                                                    },
                                                    min:{
                                                        value:0,
                                                        message:t("negative_values_not_allowed")
                                                    },
                                                    onChange: async () => {
                                                        await trigger("amount");
                                                    }

                                                })}
                                                id="amount"
                                                type="text"
                                                name='amount'
                                                placeholder='Enter amount'
                                                isInvalid={!!errors.amount}
                                            /> */}
                                            <Form.Control
                                                {...register("amount", {
                                                    required: {
                                                        value: true,
                                                        message: t("this_field_is_required"),
                                                    },
                                                    validate: (value) => {
                                                        const num = parseFloat(value);
                                                        if (isNaN(num)) return t("this_field_is_required");
                                                        if (num < 0) return t("negative_values_not_allowed");
                                                        if(num==0) return t("amount_should_greater_than_zero")
                                                        return true;
                                                    }
                                                })}
                                                id="amount"
                                                type="number" 
                                                name="amount"
                                                placeholder="Enter amount"
                                                isInvalid={!!errors.amount}
                                                onChange={async (e) => {
                                                    await trigger("amount");
                                                }}
                                            />

                                            <Form.Control.Feedback type="invalid">
                                                {errors.amount && errors.amount.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                )}
                                {activeStep === 2 && (

                                    <div className="row">
                                        <div className="col-md-3 pe-0">
                                            <div
                                                className="nav nav-tabs payment_tab_reg"
                                                id="nav-tab"
                                                role="tablist"
                                            >
                                                {paymentMethods?.data?.methods.map((tab) => (
                                                    <React.Fragment key={tab.id}>
                                                        <button
                                                            key={tab.id}
                                                            className={`nav-link ${activeTab === tab.id ? "active" : ""
                                                                }`}
                                                            id={`nav-${tab.id}-tab`}
                                                            data-bs-toggle="tab"
                                                            data-bs-target={`#nav-${tab.id}`}
                                                            type="button"
                                                            role="tab"
                                                            aria-controls={`nav-${tab.id}`}
                                                            aria-selected={formValues.paymentType === tab.id}
                                                            {...register("paymentType", { required: true })}
                                                            onClick={() => handlePaymentTabClick(tab.id, tab.title)}
                                                        >
                                                            <i className={tab?.icon}></i> {t(tab.title)}
                                                        </button>
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="col-md-9 ps-0">
                                            <div
                                                className="tab-content p-3 border mb-5 payment__tab_cnt"
                                                id="nav-tabContent"
                                            >
                                                {formValues.paymentType === undefined && (
                                                    <p>
                                                        <strong>{t("preferredPaymentPlaceholder")}</strong>
                                                    </p>
                                                )}
                                                {paymentMethods?.data?.methods?.map((tab) => (
                                                    <div
                                                        key={tab.id}
                                                        className={`tab-pane fade ${activeTab === tab.id ? "show active" : ""
                                                            }`}
                                                        id={`nav-${tab.id}`}
                                                        role="tabpanel"
                                                        aria-labelledby={`nav-${tab.id}-tab`}
                                                    >

                                                        {
                                                            tab.title === "coin-payment" && (
                                                                <CoinPayment handleSubmit={handleSubmit} />
                                                            )

                                                        }
                                                        {tab.title === "free-joining" && (
                                                            <p>
                                                                <strong>{t("freeJoinPlaceHolder", { type: "repurchase" })}</strong>
                                                            </p>
                                                        )}
                                                        {tab.title === "bank-transfer" && (
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div >
                                                                        <label

                                                                        >
                                                                            {t("tranfer-details")}
                                                                        </label>
                                                                        <div style={{ marginBottom: "10px" }} className="admin-coin-address">

                                                                            <span>{t('coin_id')} : {adminCoindetails?.data?.data}</span>


                                                                        </div>

                                                                    </div>
                                                                    <div className="form-group mb-2">
                                                                        <label htmlFor="fileUpload">
                                                                            {t("file_upload")}
                                                                        </label>
                                                                        <input
                                                                            id="fileUpload"
                                                                            type="file"
                                                                            placeholder=""
                                                                            className="form-control"
                                                                            name="fileUpload"
                                                                            onChange={handleFileChange}
                                                                        />
                                                                        {fileResponse?.success &&
                                                                            formValues?.bankReceipt !== undefined && (
                                                                                <div style={{ color: "green" }}>
                                                                                    {t(fileResponse?.success)}
                                                                                </div>
                                                                            )}
                                                                        {fileResponse?.error && (
                                                                            <div style={{ color: "red" }}>
                                                                                {t(fileResponse?.error)}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12">
                                                                    <button
                                                                        href="#"
                                                                        className="btn btn-sm btn-primary mt-3"
                                                                        onClick={handleUpload}
                                                                        disabled={
                                                                            Upload.status === "loading" ||
                                                                            formValues?.bankReceipt ||
                                                                            document.getElementById("fileUpload")
                                                                                ?.value === "" ||
                                                                            file === null
                                                                        }
                                                                    >
                                                                        {Upload.status === "loading"
                                                                            ? "Uploading..."
                                                                            : t("upload")}
                                                                    </button>
                                                                </div>
                                                                {Upload?.data?.status === true &&
                                                                    formValues?.bankReceipt !== undefined && (
                                                                        <>
                                                                            <img
                                                                                src={`${BASE_URL}${Upload?.data?.data?.file?.path}`}
                                                                                alt="receipt"
                                                                                style={{
                                                                                    width: "160px",
                                                                                    height: "160px",
                                                                                    padding: "5px",
                                                                                }}
                                                                            />
                                                                            <button
                                                                                className="recipt_checkout_address_btn"
                                                                                onClick={handleDeleteBankReciept}
                                                                            >
                                                                                <i className="fa fa-xmark"></i>
                                                                            </button>
                                                                            <div style={{ color: "green" }}>
                                                                                {Upload?.data?.message}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                {Upload?.data?.status === false && (
                                                                    <span className="error-message-validator">
                                                                        {Upload?.data?.message}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )}
                                                        {tab.title != "coin-payment" &&
                                                            <div className="checkout_continuew_btn">
                                                                {
                                                                    <button
                                                                        className="btn btn-primary checkout_cnt_btn"
                                                                        disabled={reinvestment.isLoading || tab.title == "bank-transfer" ? submitButtonActive : false}
                                                                        onClick={() => handleSubmit(tab.id, null)}
                                                                    >
                                                                        {t("pay")}
                                                                    </button>
                                                                }
                                                            </div>}

                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className={`btn btn-secondary ${reinvestment.isLoading ? 'btn-disabled' : ''}`}
                                    onClick={close}
                                    disabled={reinvestment.isLoading}
                                >
                                    {t('close')}
                                </button>
                                {activeStep === 1 ? (
                                    <SubmitButton
                                        className="btn btn-primary"
                                        text="next"
                                        click={nextHandler}
                                    />
                                ) : (
                                    <SubmitButton
                                        className={`btn btn-primary ${reinvestment.isLoading ? 'btn-disabled' : ''}`}
                                        text="previous"
                                        click={previousHandler}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}



export default FundModal